import React from "react";

import Timer from "../img/timer.svg";
import UserChart from "../img/user-chart.svg";

export interface KPIMetric {
  image: React.ReactNode;
  description: string;
  value: string;
}

export interface MonthlyKPIData {
  [key: string]: KPIMetric[];
}

export const monthlyKPIData: MonthlyKPIData = {
  "2024-01": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 89",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "120 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "6.8",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "48%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "62%",
    },
  ],
  "2024-02": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 112",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "105 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.1",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "52%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "65%",
    },
  ],
  "2024-03": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 134",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "98 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.2",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "54%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "67%",
    },
  ],
  "2024-04": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 156",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "95 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.4",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "56%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "69%",
    },
  ],
  "2024-05": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 178",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "92 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.5",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "58%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "71%",
    },
  ],
  "2024-06": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 201",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "88 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.6",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "60%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "73%",
    },
  ],
  "2024-07": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 223",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "85 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.7",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "62%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "75%",
    },
  ],
  "2024-08": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 245",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "82 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.8",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "64%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "77%",
    },
  ],
  "2024-09": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 267",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "80 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.9",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "66%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "79%",
    },
  ],
  "2024-10": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 289",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "78 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "8.0",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "68%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "81%",
    },
  ],
  "2024-11": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 50",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "95 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "6.5",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "45%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "58%",
    },
  ],
  "2024-12": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 150",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "90 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "6.8",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "48%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "62%",
    },
  ],
  "2025-01": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 300",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "85 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.2",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "52%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "65%",
    },
  ],
  "2025-02": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 600",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "82 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.4",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "54%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "67%",
    },
  ],
  "2025-03": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 900",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "80 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.6",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "56%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "69%",
    },
  ],
  "2025-04": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 1200",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "78 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.8",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "58%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "71%",
    },
  ],
  "2025-05": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 1800",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "75 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "8.0",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "60%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "73%",
    },
  ],
  "2025-06": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 1900",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "72 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "8.2",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "62%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "75%",
    },
  ],
  "2025-07": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 800",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "85 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.5",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "55%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "68%",
    },
  ],
  "2025-08": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 80",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "95 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "6.8",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "48%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "60%",
    },
  ],
  "2025-09": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 200",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "88 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.0",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "50%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "63%",
    },
  ],
  "2025-10": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 500",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "82 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.3",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "53%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "66%",
    },
  ],
  "2025-11": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 900",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "78 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.5",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "56%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "69%",
    },
  ],
  "2025-12": [
    {
      image: (
        <i className="fa-solid fa-users text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "New Clients",
      value: "+ 1200",
    },
    {
      image: (
        <img
          src={Timer}
          alt="timer"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Average Response Time",
      value: "75 sec",
    },
    {
      image: (
        <i className="fa-solid fa-trophy text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Average Lead Quality Score",
      value: "7.7",
    },
    {
      image: (
        <img
          src={UserChart}
          alt="user-chart"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ),
      description: "Converted Clients",
      value: "58%",
    },
    {
      image: (
        <i className="fa-solid fa-chart-simple text-darkBlue absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      ),
      description: "Conversion Rate",
      value: "71%",
    },
  ],
};

export const getKPIDataForMonth = (date: any): KPIMetric[] => {
  if (!date) {
    const currentDate = new Date();
    const monthKey = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}`;
    return monthlyKPIData[monthKey] || monthlyKPIData["2025-07"];
  }

  const monthKey = `${date.year()}-${String(date.month() + 1).padStart(
    2,
    "0"
  )}`;
  return monthlyKPIData[monthKey] || monthlyKPIData["2025-07"];
};
